import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = '2026';

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-foreground-900 font-heading font-bold text-xl mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-white rounded-lg">
                <i className="ri-star-fill text-base"></i>
              </span>
              <span>精品一区</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              精品一区是您发现高质量精选内容的首选平台，汇聚严选优质资源，为您提供极致的内容体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:text-primary-500 hover:bg-background-200 transition-colors duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#" className="hover:text-primary-500 transition-colors">精选分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={'/category/' + cat.slug}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#" className="hover:text-primary-500 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">加入我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <a href="#" className="hover:text-primary-500 transition-colors">联系方式</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                <span>contact@jingpinyiqu.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-primary-500 mt-0.5"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                <span>北京市朝阳区建国路88号精品大厦</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 精品一区 JingPinYiQu. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">京ICP备2024000001号</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}